export const B2C_ADDRESSES_LIMIT_REACHED_MSG = {
    message: "You've reached the maximum of 50 addresses. To add a new address, you must first delete an existing one.",
};
export const B2B_ADDRESSES_LIMIT_REACHED_MSG = {
    message: "You've reached the maximum of 500 addresses. To add a new address, you must first delete an existing one.",
};
export const INSTANT_CHECKOUT_NO_DEFAULT_PAYMENT_MSG = {
    message: "You haven't saved a credit card. Set up how you pay before shopping with Instant Checkout again.",
};
export const INSTANT_CHECKOUT_NO_DEFAULT_ADDRESS_MSG = {
    message: "You haven't saved an address. Set up where to get items before shopping with Instant Checkout again.",
};
export const INSTANT_CHECKOUT_NO_DEFAULT_ADDRESS_AND_PAYMENT_MSG = {
    message: 'You haven’t saved an address or a credit card. Update your settings before shopping with Instant Checkout again.',
};
export const PROHOUSE_ACCOUNTS_NO_T2C_AUTHORIZED_TENDER_MSG = {
    message: 'Add a Shop line of credit or a Credit Card and authorize for Text2Confirm to make Remote Purchases available for Project lines of credit.',
};
